import { dummyConsole, dummyOrders, dummyProfits } from "../dummyData";
import {
  handleError,
  handleRequestError,
  hostUrl,
  jsonHeaders,
  message,
  request,
  withDummyFallback,
} from "./core";

export const stopAllTradeNSE = () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl("/users/stop/trade?exchange=NSE"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) => withDummyFallback(response.data, dummyOrders))
    .catch((error) => handleRequestError(error, dummyOrders));
};

export const stopAllTradeNFO = () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl("/users/stop/trade?exchange=NFO"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) => {
      message.success("Stopping all options trades");
      withDummyFallback(response.data, dummyConsole);
      return true;
    })
    .catch((error) => handleRequestError(error, dummyConsole));
};

export const stopIndivisualAllTrade = (id, username, exchange) => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl(`/users/stop/trade?id=${id}&exchange=${exchange}`),
    headers: jsonHeaders(),
  };
  return request(config)
    .then(() => {
      message.success(`Stopping trade for ${username}`);
      return true;
    })
    .catch((error) => {
      handleError(error);
      message.error(error?.response?.data?.message || "Server is Down");
      return false;
    });
};

export const stopAllTradeNormal = () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl("/users/stop/trade/normal"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) => withDummyFallback(response.data, dummyProfits))
    .catch((error) => handleRequestError(error, dummyProfits));
};
